module.exports = __webpack_public_path__ + "static/media/collection-bird-10.2d2e7e92.png";